"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.populateMediaDurationOnActions = populateMediaDurationOnActions;
var _missionStateConstants = require("../constants/missionStateConstants");
/**
 * populateMediaDurationOnActions - populates media duration on the given list of actions.
 *
 * @param {Array<Actions>} actions [MUTATES] - the actions to add the media durations to
 * @param {{getVideoDuration: (url: string) => Promise<number>, getAudioDuration: (url: string) => Promise<number>}} getDurations - functions with get durations for different types of media. The promises returned by these functions must be infallible (ie. always returns a number).
 *
 * @returns Array<Actions> - the original actions array (with the media duration populated)
 */
async function populateMediaDurationOnActions(actions, getDurations) {
  const videoObjectsToAddDurationTo = {};
  const audioObjectsToAddDurationTo = {};
  actions.forEach(action => {
    if (action.type === 'VIDEO_SCREEN' || action.type === 'VIDEO_OVERLAY' || action.type === 'VOCAL_TRACK') {
      if (action.type === 'VOCAL_TRACK') {
        // $FlowFixMe actions are not typed correctly in mission-toolkit
        const url = action.audioUrl;
        audioObjectsToAddDurationTo[url] ??= [];
        // $FlowFixMe actions are not typed correctly in mission-toolkit
        audioObjectsToAddDurationTo[url].push(action);
      } else {
        // $FlowFixMe actions are not typed correctly in mission-toolkit
        const url = action.url;
        videoObjectsToAddDurationTo[url] ??= [];
        // $FlowFixMe actions are not typed correctly in mission-toolkit
        videoObjectsToAddDurationTo[url].push(action);
      }
    } else if (action.type === 'ACTIVATE_STATION' &&
    // $FlowFixMe actions are not typed correctly in mission-toolkit
    action.stationData.stationId === 'CREATIVE_CANVAS') {
      const issues = [];
      if (
      // $FlowFixMe actions are not typed correctly in mission-toolkit
      action.stationData.variant === _missionStateConstants.CREATIVE_CANVAS_STATION.VARIANT.GENERAL_ISSUE) {
        // $FlowFixMe actions are not typed correctly in mission-toolkit
        issues.push(action.stationData.issue);
      } else {
        // $FlowFixMe actions are not typed correctly in mission-toolkit
        issues.push(...action.stationData.issues);
      }
      const medias = [];
      issues.forEach(issue => {
        if (issue.rubric.failMedia) {
          medias.push(issue.rubric.failMedia);
        }
        if (issue.rubric.successMedia) {
          medias.push(issue.rubric.successMedia);
        }
      });
      medias.forEach(media => {
        if (media.type === 'VIDEO') {
          const url = media.url;
          videoObjectsToAddDurationTo[url] ??= [];
          // $FlowFixMe actions are not typed correctly in mission-toolkit
          videoObjectsToAddDurationTo[url].push(media);
        }
      });
    }
  });
  const promises = [];
  Object.keys(videoObjectsToAddDurationTo).forEach(url => {
    promises.push(getDurations.getVideoDuration(url).then(durationInMilliseconds => {
      videoObjectsToAddDurationTo[url].forEach(object => object._mediaDuration = durationInMilliseconds);
    }));
  });
  Object.keys(audioObjectsToAddDurationTo).forEach(url => {
    promises.push(getDurations.getAudioDuration(url).then(durationInMilliseconds => {
      audioObjectsToAddDurationTo[url].forEach(object => object._mediaDuration = durationInMilliseconds);
    }));
  });
  return Promise.all(promises).then(() => actions);
}